import React from 'react';
import css from '../modal-popup.module.css';
import { Button } from '@weezevent/nacre';

function ModalButton({ zone }) {
    const color = React.useMemo(() => {
        if (Object.keys(zone.seat_categories).length) {
            // get first cat color
            return zone.seat_categories[Object.keys(zone.seat_categories)[0]].color;
        }
    }, [zone]);

    return (
        <Button
            basic={false}
            fluid
            style={{ backgroundColor: color }}
            inverted={false}
            label={
                <div className={css['modal-zone-label']}>
                    <span>{zone.name}</span>
                </div>
            }
        />
    );
}

export default ModalButton;
